import React from 'react';
import { useLocale } from '../context/LocaleContext';
import { BRAND_LOGO_SRC } from '../config/brandLogo';

interface LogoProps {
  size?: number;
  withWordmark?: boolean;
  className?: string;
  locale?: 'tr' | 'en';
}

export default function Logo({ size = 48, withWordmark = true, className = '', locale: localeProp }: LogoProps) {
  const { brandName, locale: ctxLocale } = useLocale();
  const locale = localeProp || ctxLocale;
  const isEn = locale === 'en';

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={BRAND_LOGO_SRC}
        alt={brandName}
        width={size}
        height={size}
        className="shrink-0 object-contain"
        onError={(e) => {
          (e.target as HTMLImageElement).src = '/assets/parkmesaj-icon.png';
        }}
      />
      {withWordmark && (
        <span
          className="font-bold text-white tracking-wide text-xl leading-none"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {isEn ? (
            <>Ping<span className="text-[#F76404]">Parking</span></>
          ) : (
            <>Park<span className="text-[#F76404]">Mesaj</span></>
          )}
        </span>
      )}
    </span>
  );
}
